

const CFS = document.querySelector('.cfs-container');


if (CFS) {
    //番号付きリストのスタイルを変更
    const numberLists = Array.from(CFS.querySelectorAll('ol > li'));
    //console.log(numberLists);

    numberLists.forEach((item,index) => {
        //console.log(index+':'+item);
        item.innerHTML = '<span class="number">'+(index+1)+'</span>'+item.innerHTML;
    });
}